import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {
    httpGetMedicalRecordCover,
    HttpGetMedicalRecordCoverOptions
} from '@/features/medical-records/http/medicalRecords.http'
import {QUERY_KEYS} from '@/queryClient'
import {raise} from '@/utilities/helpers'
import {PatientExtended} from '@/features/patients/types'
import {ResponseType} from '@/types'

export const useGetMedicalRecord = (
    urlParams: HttpGetMedicalRecordCoverOptions['urlParams'],
    options?: Omit<UseQueryOptions<PatientExtended['medicalRecord']>, 'queryFn' | 'queryKey'>
) =>
    useQuery({
        ...options,
        queryKey: [QUERY_KEYS.MEDICAL_RECORD, urlParams],
        queryFn: () =>
            httpGetMedicalRecordCover({
                urlParams: {
                    medicalRecordId: urlParams?.medicalRecordId || raise('medicalRecordId is required')
                },
                params: {
                    responseType: ResponseType.Enum.extended
                }
            })
    })
